export const i18n_de = {
  nav: {
    ressources: "Ressourcen",
    mv_tiles: "MV Exklusiv",
    engine_free: "Engine Free",
    games: "Spiele",
    halloween: "Halloween im Hexenhaus",
    au_schwarte: "Au Schwarte!",
    hans_dampf: "Hans Dampf Maschine",
    cthulhu: "Cthulhu Clicker",
    nachtschatten: "Nachtschatten",
    bloxxs: "Bloxxs",
    kontakt: "Kontakt",
    apps: "Apps",
    draw_it: "Draw It!",
    dreaming_fox: "Dreaming Fox",
  },
  mv: {
    heading: "<- Wähle ein Paket",
    download: "Download Paket",
    licence_mv: `
    <h2>Lizenz </h2></br>
    Bei den Ressourcen handelt es sich um Edits des MV-RTPs, daher musst du den RPG Maker MV besitzen, wenn du sie verwenden willst. Die Ressourcen dürfen ausschließlich im RPG Maker verwendet werden!
    <ul>
    <li> Für nicht kommerzielle Spiele sind die Ressourcen frei verwendbar. </li>
    <li> Nutzt du sie für kommerzielle Projekte, möchte ich eine Version des fertigen Spiels haben.</li>
    <li> Credits gehen an Kadokawa/Enterbrain, an mich (NuraRay) und an die Künslter, die in einigen Cowork-Sets mit involviert waren.</li>
    <li> Edits für eigene Zwecke sind uneingeschränkt erlaubt. Kein Repost meiner Tiles oder daraus entstandene Edits!</li>
      </ul>`,
    licence_free: `
    <h2>Lizenz </h2></br>
      Die Ressourcen wurden alle von mir selbst erstellt und können damit in jeder Enginge verwendet werden. Sie sind aber optimiert für den RPG Maker MV.
    <ul>
      <li> Für nicht kommerzielle Spiele sind die Ressourcen frei verwendbar. </li>
      <li> Für kommerzielle Projekte, musst du eine Lizenz erwerben. </li>
      <li> Jeder mit Lizenz erhält außerdem Zugang zu allen weiteren Baum-Tiles, die in dem Set entstehen. Geplant sind weitere Bäume, Variationen, Editionen passend zu den Jahreszeiten und und und. Du kannst auch gern Wünsche äußern! ;)</li>
      <li> Eine Lizenz, bzw Zugang dazu bekommst du über die MakerMole-Website: https://makermoles.jimdo.com/ressourcen/makerunabh%C3%A4ngige-ressourcen/</li>
      <li> Credits gehen an mich (NuraRay) </li>
      <li> Edits für eigene Zwecke sind uneingeschränkt erlaubt.</li>
      <li> Kein Repost meiner Tiles oder daraus entstandene Edits!</li>
    </ul>`,
  },
  lang_de: "deutsch",
  lang_en: "englisch",
  game: {
    release: "Release",
    engine: "Engine",
    platform: "Platform",
    genre: "Genre",
    playtime: "Spielzeit",
    language: "Sprache",
    descr: "Beschreibung",
    web: "Links und Let's Plays",
  },
  app: {
    download: "Zeig mir mehr!",
  },
  contact: {
    social: "Besucht mich auf Social Media!",
    subtext: `Hey es freut mich, dass du hier bist! Offensichtlich hast du Interesse an
    meinem Content, das ist cool! Ich habe weitere Spuren im Netz
    hinterlassen, hier die wichtigsten Links!
    <br /><br />
    <strong>Du willst noch mehr von mir sehen?</strong> -> Dann check gern
    mein Instagram Profil aus oder folge mir auf Twitter.<br />
    <strong>Du hast eine Frage oder ein Anliegen?</strong> -> Kontaktiere mich
    gern per Mail oder über einen anderen Kanal!`,
    insta: ` <h3>Instagram</h3>
    Mehr Pixelart von mir! Custom Tilesets, individuelle Avatare und
    sonstige Game Assets. Eben mein Portfolio!`,
    mail: ` <h3>Mail</h3>
    Schreib' mir gern, wenn Du eine Frage oder Feedback hast! Ich freue
    mich von dir zu lesen!`,
    twitter: `    <h3>Twitter</h3>
    Hier gibts Pixelart von mir und großartige Pixelartworks von andern
    sehr talentierten Menschen :)`,
  },
  dashboard: {
    welcome: "Aloha und Willkommen!",
    about_txt: `
    Hi! Ich bin Anne!<br />
    Frontend-Developer, UX/UI Designerin und Pixelartist. Ich liebe den
    Retro-Style, Indigames und entspanntes pixeln nach einem stressigen Tag.<br> 
    Hier kannst Du meine Game Assets und bisherigen Releases entdecken. <br>
    Ich wünsche Dir viel Spaß! :3
    `,
    explore: "Was willst du zu erst entdecken?",
  },
};
